import type { PublicApiKey } from '@/apilib';
import type { createComponentPanelPreloaderApi } from './componentPanelPreloaderWrapper';

export const ComponentPanelPreloaderApiKey: PublicApiKey<
  typeof createComponentPanelPreloaderApi
> = {
  name: 'ComponentPanelPreloaderApi',
  public: true,
};
